//swiperまるごとセット
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

export default class Banner {
    constructor() {
        this.init();
    }

    init() {
        this.setSwiper();
    }

    setSwiper() {
        const topbanner = document.querySelector(".top__bnr");
        const banner = document.querySelector(".top__bnr__swiper");
        const banneritems = [...banner.querySelectorAll(".swiper-slide")];

        var loopval = true;

        if (banneritems.length === 1) {
            topbanner.classList.add("-bannerone");
            loopval = false;
        };

        const option = {
            //autoplay: { delay: 5000 },
            slidesPerView: "auto",
            loop: loopval,
            centeredSlides: true,

            pagination: {
                el: ".bnr_swiper-pagination",
                clickable: true,
            },

            breakpoints: {
                835: {
                    /* loop: true,
                    centeredSlides: true, */
                },
            },
        };

        const swiper = new Swiper(".top__bnr__swiper", option);
    }
}
